import React, { PropsWithChildren } from "react";
import { TokenTransferStepProps } from "../../TokenTransferStep";
import TokenTransferStepButton from "../../TokenTransferStepButton";
import { useController } from "react-hook-form";
import SecondaryInput from "nvs-design-system/dist/Form/SecondaryInput";
import { TokenTransferRequestFieldNames } from "../../../hooks/constants";

export default function ReceivingAddressInput({
  children,
  onContinue,
}: PropsWithChildren<TokenTransferStepProps>) {
  const {
    field: { onChange, value, name },
    formState: { isDirty },
  } = useController({
    name: TokenTransferRequestFieldNames.walletAddress,
  });

  return (
    <>
      <SecondaryInput
        name={name}
        type="text"
        aria-required="true"
        aria-invalid="false"
        aria-label="receiving address"
        value={value}
        onChange={onChange}
        placeholder="e.g.0x1ed3..."
        required
      />

      {children}

      <TokenTransferStepButton disabled={!isDirty} onClick={onContinue}>
        Continue
      </TokenTransferStepButton>
    </>
  );
}
